import InfinitySearch from './../infinity-scroll/infinity-scroll';
import Helpers from './../helpers/helpers';

export default class GlobalSearchBindings {
    constructor() {
        this.$body = $('body');
        this.fieldSearch = $('.js-global-search');
        this.searchInput = '.js-global-search';
        this.searchClose = '.js-search-close';
        this.$results = $('.js-search-result');
        this.$preloader = $('.js-preloader');
        this.$searchModal = $('.js-search-modal');

        this.openSearch();
        this.focusOut();
        this.bindEvents();

        this.iLastTimeSearch = 0;
        this.sLastSearch = '';
        this.iPage = 1;
    }

    bindEvents() {
        $(document).on('click', this.searchClose, (e) => {
            this.closeSearch(e);
        });
        $(document).on('click', '.mobile-search__clear', () => {
            console.log(123);

            let $searchInput = $(this.searchInput);

            $searchInput.val('').trigger('change');
        });
        $(document).on('click', (e) => {
            if (Helpers.isMobile()) {
                return;
            }

            let isModalOpened = this.$body.hasClass('_search-modal-opened'),
                isClickInPopup = !!$(e.target).closest('.js-search-modal').length,
                isClickInGlobalSearchInput = !!$(e.target).closest('.js-global-search').length;

            if ( !isModalOpened && !isClickInPopup || isClickInGlobalSearchInput ) return;

            this.closeSearch(e);
        });
        $(document).keyup((e) => {
            if(e.keyCode === 27 && this.$body.addClass('_search-modal-opened')) {
                this.closeSearch(e);
            }
        });
    }

    openSearch() {
        $(document)
            .on('input', this.searchInput, (e) => {
                let $target = $(e.target),
                    fieldValue = $target.val().trim();

                if (fieldValue.length >= 3) {
                    this.openSearchBox();
                    this.showPreloader();
                }

                if (fieldValue.length >= 3 && fieldValue != this.sLastSearch) {
                    this.iPage = 1;

                    InfinitySearch.setDefaultPage('global-search');
                    this.getSearchResult(fieldValue);
                }
            });

        this.fieldSearch.on('click', (e) => {
            let $target = $(e.target),
                fieldValue = $target.val();

            if (fieldValue.length >= 3) {
                this.openSearchBox();
            }
        });
    }

    openSearchBox() {
        this.$results.fadeIn('slow');
        $('.js-search-modal').fadeIn('slow');
        this.$body.addClass('_search-modal-opened');
    }

    focusOut() {
        this.fieldSearch.focusout((e) => {
            let $target = $(e.target),
                fieldValue = $target.val();

            if (fieldValue.length < 3) {
                this.$results.fadeOut('slow');
            }
        });
    }

    showPreloader() {
        this.$preloader.show();
    }

    hidePreloader() {
        this.$preloader.hide();
    }

    closeSearch() {
        this.$body.removeClass('_search-modal-opened');
        this.$searchModal.fadeOut('slow');
    }

    hasScrollBar (elemClassName) {
        let elem = document.querySelector(elemClassName),
            result = elem.scrollHeight > $(elemClassName).height();

        return result;
    }

    getSearchResult(sSearch) {
        this.iLastTimeSearch = new Date().getTime();

        setTimeout(() => {
            var iCurrentTime = new Date().getTime();
            if (iCurrentTime >= this.iLastTimeSearch + 300) {

                this.sLastSearch = sSearch;
                $.request('ShopaholicSearch::onAjaxSearch', {
                    data: {'search': sSearch, 'page': this.iPage},
                    update: {'jade-search-result.htm': '.search-area__inner'},
                    success: (data) => {
                        if (data.value != this.sLastSearch) {
                            return;
                        }
                        
                        if (this.iPage == 1) {
                            $('.search-area__inner').html('' + data['jade-search-result.htm']);
                        } else {
                            $('.search-area__inner').append(data['jade-search-result.htm']);
                        }

                        let isEmpty = data['jade-search-result.htm'].indexOf('search-area__nothing') >= 0;

                        if (!isEmpty && this.hasScrollBar('.search-area__inner')) {
                            this.$searchModal.addClass('_has-result');
                        } else {
                            this.$searchModal.removeClass('_has-result');
                        }

                        this.hidePreloader();
                    }
                });
            }
        }, 300);
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/search-area/GlobalSearchBindings.js